<template lang="pug">
    .info_popup
        Closer(@click.native="$emit('close')")
        .content.person(v-if="info.type==='person'")
            img(:src="info.content.link" alt="")
            .name(v-html="info.content.name")
            .date(v-html="info.content.date")
            .text(v-html="info.content.text")
        .content(v-if="info.type==='video'")
            video-player(ref="videoPlayer"
                :options="playerOptions"
                :playsinline="true")
            .name(v-html="info.content.name")
            .date(v-html="info.content.date")
            .text(v-html="info.content.text")
        .content.slider(v-if="info.type==='slider'")
            .swiper-container
                .swiper-wrapper
                    .swiper-slide(v-for="slide in info.content")
                        img(:src="slide.VALUE" alt="")
                        .details(v-if="slide.DESCRIPTION" v-html="slide.DESCRIPTION")
            .swiper-pagination


</template>

<script>
    export default {
        name: "InfoPopup",
        props: ['info'],
        data:()=>({
            slider: null,
            playerOptions: {
                height: '360',
                autoplay: false,
                language: 'ru',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: "",
                }],
                poster: "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
            },
        }),
        methods:{
            initSlider() {
                this.slider = new Swiper('.info_popup .swiper-container', {
                    speed: 500,
                    loop: true,
                    autoHeight: true,
                    pagination: {
                        el: '.info_popup .swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                });
            },
        },
        created() {
            this.$store.state.hideBurger = true;
        },
        beforeDestroy() {
            this.$store.state.hideBurger = false;
        },
        beforeMount(){

        },
        mounted() {
            if (this.info.type === 'video') {
                this.playerOptions.techOrder = ~this.info.content.link.indexOf('youtu') ? ['youtube'] : ['html5'];
                this.playerOptions.sources[0].type = ~this.info.content.link.indexOf('youtu') ? 'video/youtube' : 'video/mp4';
                this.playerOptions.sources[0].src = this.info.content.link;
            }
            if (this.info.type==='slider'){
                this.initSlider();
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";

    .info_popup .content{
        .video-player{
            position: static;
            margin-bottom: 7vw;
            .video-js {
                width: 90vw;
                height: 52vw;
                .vjs-big-play-button {
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
</style>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";

    .info_popup {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 55;

        &:before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: linear-gradient(27deg, rgb(0, 34, 119) 0%, rgb(15, 82, 182) 60%, rgb(30, 130, 245) 100%);
            opacity: 0.7;
        }

        .content{
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: auto;

            height: 100%;
            padding: 17vh 0 14vh;
            text-align: center;
            &.person{
                img{
                    max-width: 46%;
                }
            }
            &.slider{
                img{
                    max-width: 90%;
                }
            }
            img{
                margin-bottom: 7vmin;
            }
            .name{
                font-family: Pobeda;
                font-weight: bold;
                font-size: 7.6vw;
            }
            .date{
                margin-bottom: 2vmin;
                font-family: Pobeda;
                font-weight: bold;
                font-size: 5.5vw;
            }
            .text{
                max-width: 90%;
                font-family: Arial;
                font-size: 3.5vw;
                line-height: 1.9;
            }
            .swiper-container{
                width: 100%;
                .swiper-slide{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    max-height: 70vh;
                    overflow: auto;
                }
            }
            .details{
                padding: 0 5.5vw;
                font-family: Pobeda;
                font-size: 7.5vw;
                line-height: 1.1;
                font-weight: bold;
                text-align: left;
            }

        }

        .close-button {
            position: absolute;
            z-index: 5;
        }
    }
</style>
